import React from 'react';
import Icon from '../../../components/AppIcon';
import { Checkbox } from '../../../components/ui/Checkbox';
import Select from '../../../components/ui/Select';

const EmailDigestOptions = ({ preferences, onUpdate }) => {
  const frequencyOptions = [
    { value: 'instant', label: 'Instant' },
    { value: 'daily', label: 'Daily Digest' },
    { value: 'weekly', label: 'Weekly Summary' },
    { value: 'off', label: 'Off' },
  ];

  const previewFormatOptions = [
    { value: 'summary', label: 'Summary' },
    { value: 'detailed', label: 'Detailed' },
    { value: 'minimal', label: 'Minimal' },
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-start gap-3 mb-6">
        <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
          <Icon name="Mail" size={20} className="text-primary" />
        </div>
        <div className="flex-1">
          <h2 className="text-lg font-semibold text-foreground">Email Digest Options</h2>
          <p className="text-sm text-muted-foreground mt-1">
            Control when and how you receive email notifications and digests.
          </p>
        </div>
      </div>
      <div className="space-y-6">
        {/* Digest Timing */}
        <div className="space-y-3">
          <label className="text-sm font-medium text-foreground">Digest Delivery Times</label>
          <Checkbox
            checked={preferences?.morningDigest || false}
            onChange={(e) => onUpdate({ morningDigest: e?.target?.checked })}
            label="Morning Digest (8:00 AM)"
            description="Receive a summary of overnight activity and today's priorities"
          />
          <Checkbox
            checked={preferences?.eveningDigest || false}
            onChange={(e) => onUpdate({ eveningDigest: e?.target?.checked })}
            label="Evening Digest (6:00 PM)"
            description="Get a recap of today's activity and tomorrow's upcoming tasks"
          />
        </div>

        {/* Frequency Selection */}
        <div>
          <Select
            label="Email Frequency"
            options={frequencyOptions}
            value={preferences?.frequency || 'instant'}
            onChange={(value) => onUpdate({ frequency: value })}
            description="How often you want to receive email notifications"
          />
        </div>

        {/* Preview Format */}
        <div>
          <Select
            label="Email Preview Format"
            options={previewFormatOptions}
            value={preferences?.previewFormat || 'summary'}
            onChange={(value) => onUpdate({ previewFormat: value })}
            description="Choose the level of detail in your email notifications"
          />
        </div>

        {/* Preview Example */}
        <div className="bg-muted/50 rounded-lg p-4">
          <div className="flex items-start gap-3">
            <Icon name="Eye" size={16} className="text-muted-foreground flex-shrink-0 mt-0.5" />
            <div className="text-xs text-muted-foreground">
              <p className="font-medium mb-2">Preview Format Examples</p>
              <ul className="space-y-1 list-disc list-inside">
                <li><strong>Summary:</strong> Brief overview with key highlights</li>
                <li><strong>Detailed:</strong> Complete information with all context</li>
                <li><strong>Minimal:</strong> Just the essential information</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailDigestOptions;